import React, { useEffect } from "react"
import { connect } from "react-redux"
import { generateDupontRatios } from "../../../../store/modules/financialRatios/actions";
import DateBar from "./DateBar";
import Subtitle from "./Subtitle";
import Item from "./Item";

function DupontRatios({
  dispatchGenerateDupontRatios,
  dateOrder,
  prefix,
}) {

  // Mounted
  useEffect(() => {
    handleGenerateDupontRatios();
  }, [])

  // Methods
  const handleGenerateDupontRatios = async () => {
    await dispatchGenerateDupontRatios({ dateOrder, prefix });
  }

  return (
    <div className="overflow-auto">
      <DateBar />

      <Subtitle title="Return on Asset(ROA)" />

      <Item label = "Operating Profit Margin" tooltip = "EBIT / Net Sales" percent = {true} />
      <Item label = "Asset Turnover" tooltip = "Net Sales / Average Total Asset" />
      <Item label = "Return on Asset" percent = {true} bold = {true} />

      <Subtitle title="Return on Equity(ROE)" />

      <Item label = "Tax Burden" tooltip = "Net Income / EBT" />
      <Item label = "Interest Burden" tooltip = "EBT / EBIT" />
      <Item label = "Operating Profit Margin" tooltip = "EBIT / Net Sales" percent = {true} />
      <Item label = "Asset Turnover" tooltip = "Net Sales / Average Total Asset" />
      <Item label = "Financial Leverage" tooltip = "Average Total Asset / Average Total Equity" />
      <Item label = "Return on Equity" percent = {true} bold = {true} />

      <div className="mb-10" />
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDupontRatios({ dateOrder, prefix }) {
    await dispatch(generateDupontRatios({ dateOrder, prefix }))
  },
})

export default connect(null, mapDispatchToProps)(DupontRatios)
